function Undo(props: { className?: string }) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path d="M8.75 14.583 4.583 10.417 8.75 6.25v2.917h4.583c2.155 0 3.917 1.762 3.917 3.917s-1.762 3.916-3.917 3.916h-.833v-1.667h.833c1.239 0 2.25-1.01 2.25-2.249s-1.011-2.25-2.25-2.25H8.75v2.916z" />
    </svg>
  );
}

export default Undo;
